import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../../Services/authServices";
import toast from "react-hot-toast";
import { defaultTheme, BrandPanel, NxField, NxButton, NxIcon, PageShell } from "../../components/nx";

export default function ResetPassword() {
    const navigate = useNavigate();
    const t = defaultTheme;

    const urlParams = new URLSearchParams(window.location.search);
    const userEmail = urlParams.get("email") || "";

    const [otp, setOtp] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const resetPassword = async () => {
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }
        if (!password) {
            toast.error("Please enter a new password");
            return;
        }
        if (password !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }
        setLoading(true);
        try {
            const res = await AuthService.resetPassword({ email: userEmail, otp, password } as any);
            if (res.status === 200) {
                toast.success("Password updated");
                navigate("/login");
            }
        } catch (err: any) {
            toast.error(err?.response?.data || "Unable to reset password");
        } finally {
            setLoading(false);
        }
    };

    const passwordToggle = (
        <button
            type="button"
            onClick={() => setShowPassword((s) => !s)}
            aria-label={showPassword ? "Hide password" : "Show password"}
            style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 32, height: 32, borderRadius: 6,
                background: "transparent", border: "none", cursor: "pointer", color: t.inkMute,
            }}
        >
            {showPassword ? NxIcon.eyeOff(t.inkSoft) : NxIcon.eye(t.inkSoft)}
        </button>
    );

    return (
        <PageShell t={t} style={{ display: "flex", height: "100vh" }}>
            {/* Brand panel — left */}
            <div style={{ width: "46%", height: "100%" }}>
                <BrandPanel t={t} />
            </div>

            {/* Form — right */}
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
                <form
                    onSubmit={(e) => { e.preventDefault(); resetPassword(); }}
                    style={{ width: "100%", maxWidth: 380 }}
                >
                    <div style={{ marginBottom: 32 }}>
                        <h1 style={{
                            fontFamily: '"Instrument Serif", serif',
                            fontSize: 38, fontWeight: 400, lineHeight: 1.05,
                            color: t.ink, letterSpacing: "-0.01em", margin: 0,
                        }}>Reset password.</h1>
                        <div style={{ fontSize: 14, color: t.inkSoft, marginTop: 8 }}>
                            Enter the OTP sent to your email and choose a new password.
                        </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        <NxField t={t} label="Email" name="email" value={userEmail} disabled onChange={() => { }} />
                        <NxField t={t} label="OTP" name="otp" value={otp} placeholder="Enter the 6-digit OTP" onChange={(e) => setOtp(e.target.value)} />
                        <NxField
                            t={t} label="New password" name="password"
                            type={showPassword ? "text" : "password"}
                            value={password} placeholder="Enter your new password"
                            onChange={(e) => setPassword(e.target.value)}
                            trailing={passwordToggle}
                        />
                        <NxField
                            t={t} label="Confirm password" name="confirmPassword"
                            type={showPassword ? "text" : "password"}
                            value={confirmPassword} placeholder="Re-enter your new password"
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />

                        <NxButton t={t} kind="primary" w="100%" icon={NxIcon.arrowRight("#fff")} type="submit" disabled={loading}>
                            {loading ? "Resetting..." : "Reset password"}
                        </NxButton>

                        <div style={{ textAlign: "center", fontSize: 13, color: t.inkSoft, marginTop: 8 }}>
                            Back to{" "}
                            <a
                                style={{
                                    color: t.ink, fontWeight: 500, textDecoration: "none",
                                    borderBottom: `1px solid ${t.ink}`, paddingBottom: 1, cursor: "pointer",
                                }}
                                onClick={() => navigate("/login")}
                            >
                                Sign in
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </PageShell>
    );
}
